export const formatAmount = (amount: number) => amount.toFixed(2);
export const formatCHFAmount = (amount: number) => `${amount.toFixed(2)} CHF`;
